import { Button, ContentFilters, ContentTopBar } from 'components';
import { AddNotificationTemplateModal } from 'features/notification/components/modal/AddNotificationTemplateModal';
import { NotificationTemplateFilterForm } from 'features/notification/components/notification-main-filter/notification-template-filter-form';
import {  NotificationTemplateFilterFormValues } from 'features/notification/components/type';
import { useState } from 'react';
import { CompanyType } from 'types';
type VendingTopBarProps = {
  getInitialFilterValues: NotificationTemplateFilterFormValues;
  handleFilter: (values: NotificationTemplateFilterFormValues) => void;
  refetch: any,
};
export const NotificationTopBarTemplate = ({
  getInitialFilterValues,
  handleFilter,
  refetch,

}: VendingTopBarProps) => {
  useState<CompanyType>();

  const formId = 'notification-template-filters-form';
  const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);
  //const [templateEditData, setTemplateEditData] = useState<any>(undefined);

  const handleOpenModal = () => {
    setShowAddItemModal(true)
    document.body.style.overflow = 'hidden';
  }

  const handleCloseModal = () => {
    setShowAddItemModal(false)
    document.body.style.overflow = 'visible';
  }

  return (
    <>
      <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
        <AddNotificationTemplateModal onClose={handleCloseModal} refetch={refetch} showAddItemModal={showAddItemModal} templateEditData={null}/>
      </div>
      <ContentTopBar
        title={'Notification Template'}
        renderButtons={
          <>
            <Button
              type='primary'
              onClick={handleOpenModal}
            >
             + Create New Template
            </Button>
          </>
        }
      />

      <ContentFilters formId={formId}>
        <NotificationTemplateFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
